import React from "react";
import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import styles from "./BannerContent.module.scss";
import BackgroundLayout from "../../components/custom-backgrounds/BackgroundLayout";
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { useTranslation } from "react-i18next";
import { SKY_BLUE } from "../../utility/constants/common-constants";
import HtmlContent from "../../components/html-content/HtmlContent";

interface BannerContentProps {
  html?: boolean;
  title: string;
  message: string;
  icon?: React.ReactNode;
}

const BannerContent: React.FC<BannerContentProps> = ({
  html,
  title,
  message,
  icon,
}) => {
  const isMobile = useMediaQuery("(max-width: 900px)");
  const height = {
    xs: "15.38rem",
    sm: "16.88rem",
    md: "16.31rem",
  };
  const { t } = useTranslation();
  return (
    <BackgroundLayout
      height={height}
      variant={isMobile ? "welcomeOverviewMobile" : "welcomeOverviewDesktop"}
      backgroundColor={SKY_BLUE}
    >
      <Container
        maxWidth={false}
        className={styles.optOutContainer}
        style={{ margin: "6rem auto" }}
      >
        <Box className={styles.optOutBannerContent}>
          {icon && <Box className={styles.imageContainer}>{icon}</Box>}
          <Box sx={{ display: "block", mb: 2 }}>
            <Typography
              variant="h1"
              mb={2}
              sx={{
                paddingTop: { md: "30px", sm: "20px" },
                paddingBottom: { md: "20px", sm: "10px" },
              }}
            >
              {title}
            </Typography>
          </Box>
          <Box sx={{ display: "block", mb: 2 }} className={styles.oopsMessage}>
            {html ? <HtmlContent htmlString={message} /> : title}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "30px",
            }}
          >
            <CustomButton
              variant="contained"
              text={t("emailUs")}
              fullWidth={isMobile ? true : false}
              href="mailto:lena-support@templehealth.org?"
            />
          </Box>
        </Box>
      </Container>
    </BackgroundLayout>
  );
};

export default BannerContent;
